export type SomDoJogo = 'movimento' | 'captura' | 'xeque' | 'roque' | 'promocao' | 'vitoria' | 'derrota' | 'empate' | 'alerta' | 'clique';
let contexto: AudioContext | null = null;

function obterContexto(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  contexto ??= new AudioContext();
  if (contexto.state === 'suspended') void contexto.resume();
  return contexto;
}

const desenhos: Record<SomDoJogo, Array<[number, number, number]>> = {
  movimento: [[235, .035, .14], [352, .025, .09]],
  captura: [[145, .055, .2], [92, .075, .16]],
  xeque: [[440, .08, .13], [660, .1, .18]],
  roque: [[180, .04, .1], [280, .04, .12], [420, .05, .14]],
  promocao: [[330, .05, .1], [495, .07, .12], [742, .12, .18]],
  vitoria: [[392, .08, .1], [523, .08, .12], [659, .16, .18]],
  derrota: [[330, .09, .13], [247, .11, .15], [196, .18, .18]],
  empate: [[294, .08, .12], [349, .08, .12], [294, .14, .14]],
  alerta: [[720, .05, .15], [720, .05, .15]],
  clique: [[420, .018, .05]]
};

export function tocarSom(tipo: SomDoJogo, volume: number, ativo: boolean): void {
  if (!ativo || volume <= 0) return;
  const ctx = obterContexto();
  if (!ctx) return;
  let cursor = ctx.currentTime;
  for (const [frequencia, duracao, ganhoMaximo] of desenhos[tipo]) {
    const oscilador = ctx.createOscillator();
    const ganho = ctx.createGain();
    oscilador.type = tipo === 'captura' ? 'triangle' : 'sine';
    oscilador.frequency.setValueAtTime(frequencia, cursor);
    ganho.gain.setValueAtTime(.0001, cursor);
    ganho.gain.exponentialRampToValueAtTime(Math.max(.0001, ganhoMaximo * volume), cursor + .008);
    ganho.gain.exponentialRampToValueAtTime(.0001, cursor + duracao);
    oscilador.connect(ganho).connect(ctx.destination);
    oscilador.start(cursor);
    oscilador.stop(cursor + duracao + .015);
    cursor += duracao * .72;
  }
}
